<div class="max-w-[1500px] mx-auto p-margin-desktop">
  <prv-opcoes-tela-principal [opcoes]="modulosUsuario"></prv-opcoes-tela-principal>
</div>